import { render, staticRenderFns } from "./RelacionarConOferta.vue?vue&type=template&id=aa924d86&scoped=true"
import script from "./RelacionarConOferta.vue?vue&type=script&lang=ts"
export * from "./RelacionarConOferta.vue?vue&type=script&lang=ts"
import style0 from "./RelacionarConOferta.vue?vue&type=style&index=0&id=aa924d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa924d86",
  null
  
)

export default component.exports